import { Reducer } from 'redux';
import { TrackActionTypes, TrackState } from './types';

const initialState: TrackState = {
  trackCounter: 0
};

const reducer: Reducer<TrackState> = (state = initialState, action: any) => {
  switch (action.type) {
    case TrackActionTypes.TRACK_EVENT_COMPLETED: {
      return {
        ...state,
        trackCounter: state.trackCounter + 1
      };
    }
    default:
      return state;
  }
};

export { reducer as TrackReducer };
